<p-multiSelect
    [id] = "id()"
    [ngModel]="isLoading() ? [] : selectedDeliveryTypeKeys()"
    
    [options]="options()"
    optionLabel="deliveryTypeName"
    optionValue="deliveryTypeKey"
    dataKey="deliveryTypeKey"
    
    [placeholder]="isLoading() ? 'Loading delivery types...' : placeHolder()"
    [loading]="isLoading()"
    [showClear]="true"

    [disabled]="isDisabled()"
    [invalid]="isInvalid()"
    
    (ngModelChange)="onModelChange($event)"
    (onBlur)="blur.emit()"

    fluid
    >
</p-multiSelect>